// extracted by mini-css-extract-plugin
export default {"section":"Section-module--section--6eb85","header":"Section-module--header--cdba9","content":"Section-module--content--2545e"};